import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApiV2 } from "../../DbCenterBaseApiV2";

export class CalcProgramApi extends DbCenterBaseApiV2 {

    public get ControllerName(): any {
        return 'calcProgram';
    }

    getProgramKey(data) {
        const programType = data.ProgramType == 'sql' ? 'S' : "P";
        const newKey = `${data.ProgramKey}-E${data.EnginerringId}-M${data.ModuleId}-${programType}${data.Id}`;
        return newKey;
    }
}